module.exports = __webpack_public_path__ + "img/promotor.a3cfdcdc.jpg";